import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import toastr from 'toastr';

export default {
  baseController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$filter',
    '$window',
    'authService',
    'uploadRevisionService',
    '$uibModal',
    'folderService',
    '$timeout',
    '$state',
    'searchService',
    'fileCheckinUploadService',
    'fileReplaceUploadService',
    'linkFilesService',
    'revisionListService',
    'EAdminFeatures',
    'signerInfoModel',
    'webApiSettings',
    'signDocumentD4sService',
    'dashboardService',
    'EFeatures',
    'roleCrudService',
    '$sce',
    'documentsPagingService',
    'previewService',
    'ETreeItemTypes',
    'digitalizationService',
    'onlyOfficeService',
    'scriptLoaderService',
    'revisionService',
    '$transitions',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $filter,
      $window,
      authService,
      uploadRevision,
      uibModal,
      folderService,
      $timeout,
      $state,
      searchService,
      fileCheckinUploadService,
      fileReplaceUploadService,
      linkFilesService,
      revisionListService,
      EAdminFeatures,
      SignerInfo,
      webApiSettings,
      signDocumentD4sService,
      dashboardService,
      EFeatures,
      roleCrudService,
      $sce,
      documentsPagingService,
      previewService,
      ETreeItemTypes,
      digitalizationService,
      onlyOfficeService,
      scriptLoaderService,
      revisionService,
      $transitions
    ) {
      $scope.revisionListService = revisionListService;

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          if (sort1 === undefined) sort1 = '';

          var sort2 = $filter('reflect')(b, column.sortExpression);
          if (sort2 === undefined) sort2 = '';

          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          if (value1 === undefined) value1 = '';

          var value2 = $filter('reflect')(b, column.expression);
          if (value2 === undefined) value2 = '';

          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        if (column.sortExpression !== undefined) {
          return (
            $filter('reflect')(a, column.sortExpression) -
            $filter('reflect')(b, column.sortExpression)
          );
        } else {
          return (
            $filter('reflect')(a, column.expression) -
            $filter('reflect')(b, column.expression)
          );
        }
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function sortOperation(a, b, column) {
        var res = 0;

        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;
        return res;
      }

      function init() {
        scriptLoaderService.load(`${webApiSettings.onlyOfficeBaseUri}web-apps/apps/api/documents/api.js`);
        $scope.revisionListService = revisionListService;
        revisionListService.documents = [];
        $scope.columns = [];
        $scope.title = '';
        $scope.lastSelected = null;
        $scope.noDocuments = $filter('translate')('NO DOCUMENTS');
        $scope.noDocumentsMessage = $filter('translate')('NO DOCUMENTS MSG');
        $scope.updateType = 1;
        $scope.justification = '';
        $scope.acceptedCheckinExtension = null;
        $scope.checkinUploader = fileCheckinUploadService.getUploader();
        $scope.replaceUploader = fileReplaceUploadService.getUploader();
        $scope.linkService = linkFilesService;
        $scope.showCancelLinkButton = true;
        $scope.PermFeature = false;
        $scope.deletePer === false;
        $scope.currentPage = $state.params.page
          ? parseInt($state.params.page)
          : 1;
        $scope.pageCount = 1;
        $scope.pageSize = 100;
        $scope.countEntries = 0;
        $scope.limiteValor = 0; // Usado no DOM para limitar exibição na tabela
        $scope.totalItem = 0;
        $scope.subTotal = 0;
        $scope.limite = 100;
        $scope.isLinkingFiles = $scope.linkService.isLinkingFiles;
        $scope.checkinUploader.onAfterAddingFile = $scope.newCheckin;
        $scope.checkinUploader.onAfterAddingAll = $scope.checkinFiles;
        $scope.replaceUploader.onAfterAddingFile = $scope.newCheckin;
        $scope.replaceUploader.onAfterAddingAll = $scope.replaceFile;
        $scope.previewDocument = null;
        $scope.previewLoading = false;
        $scope.previewUrl = null;
        $scope.isPreviewOpen = false;
        $scope.dontPreviewDocument = false;
        $scope.errPreviewDocument = false;
      }

      function carregaMais() {
        if ($scope.searchTerm !== '') {
          loadMoreFromSearch();
        } else {
          loadMoreFromDocuments();
        }
      }

      function loadMoreFromSearch() {
        $scope.loading = true;
        searchService
          .execute(
            $scope.searchTerm,
            $scope.searchFields,
            $scope.isExactSearch,
            $scope.folderFilter,
            $scope.currentPage + 1,
            $scope.pageSize
          )
          .then(
            function (data) {
              $scope.currentPage++;
              data.result.forEach(function (element) {
                $scope.revisionListService.documents.push(element);
              });
              $scope.limiteValor += data.result.length;
              $scope.description = getDescription(
                $scope.currentPage,
                $scope.pageSize,
                $scope.totalItem
              );
              $scope.loading = false;
            },
            function (data) {
              swal.fire(data.error, data.error_description);
            }
          );
      }

      function loadMoreFromDocuments() {
        if (!documentsPagingService.hasMore()) {
          return;
        }
        $scope.loading = true;
        $scope.currentPage = documentsPagingService.incrementPage();
        documentsPagingService
          .load($scope.idfolder)
          .then(res => {
            $scope.botaoAtivo = documentsPagingService.hasMore();
            $scope.totalItem = res.total;
            $scope.itens = res.items;
            $scope.count = res.items.length;
            $scope.limiteValor = res.items.length;
            $scope.documents(res.items);
            $scope.description = getDescription(
              $scope.currentPage,
              $scope.pageSize,
              $scope.totalItem
            );
            $scope.loading = false;
          });
      }

      function documents(value) {
        if (angular.isArray(value)) {
          revisionListService.documents.length = 0;

          Array.prototype.push.apply(
            revisionListService.documents,
            value
          );
        }

        return revisionListService.documents;
      }

      function clearSelection() {
        var docs = revisionListService.documents.filter((d) => d.selected);
        for (var i = 0, len = docs.length; i < len; i++) {
          docs[i].selected = false;
        }
        $scope.lastSelected = null;
      }

      function selectDocument(doc, index, event) {
        event.stopPropagation();
        if (linkFilesService.isLinkingFiles && !$scope.isLoadingLinks()) {
          $scope.showCancelLinkButton =
            linkFilesService.filesToLink.filter((x) => x.id === doc.id)
              .length === 0;
        }
        $scope.rowGuid = doc.RowGuid;

        var rightClick = event.button === 2;
        if (rightClick && doc.selected) return;

        if (!event.shiftKey && !event.ctrlKey) {
          var selected = $scope.selectedDocuments();
          if (selected.length > 1 || doc.selected === false)
            $scope.clearSelection();

          $scope.acceptedCheckinExtension = '.' + doc.extension;
          doc.selected = !doc.selected;

          $scope.lastSelected = doc.selected ? doc : null;

          if ($scope.isPreviewOpen)
            $scope.updatePreview();

          return;
        }

        if (event.ctrlKey) {
          doc.selected = !doc.selected;

          if (doc.selected) {
            $scope.lastSelected = doc;
          } else if ($scope.lastSelected === doc) {
            $scope.lastSelected = null;
          }
        } else if (event.shiftKey) {
          var first, aux, start, end, slice;

          if (
            $scope.groups !== undefined &&
            $scope.groups !== null &&
            $scope.groups.length > 0
          ) {
            var sharedByMe = $scope.groups.filter(
              (g) => g.id === 'sharedByMe'
            )[0];
            var sharedWithMe = $scope.groups.filter(
              (g) => g.id === 'sharedWithMe'
            )[0];

            var sharedBy = doc.sharedBy !== undefined && doc.sharedBy !== null;

            var items = sharedBy ? sharedWithMe.items : sharedByMe.items;

            first = $scope.lastSelected;

            if (first) {
              aux = items.indexOf(first);

              var sameGroup = aux !== -1;

              if (!sameGroup) {
                aux = sharedBy
                  ? sharedByMe.items.indexOf(first)
                  : sharedWithMe.items.indexOf(first);
              } else {
                start = index > aux ? aux : index;
                end = index > aux ? index + 1 : aux;

                slice = items.slice(start, end);
                slice.forEach((d) => {
                  d.selected = true;
                });

                $scope.lastSelected = slice[slice.length - 1];
              }
            } else {
              doc.selected = !doc.selected;

              if (doc.selected) {
                $scope.lastSelected = doc;
              } else if ($scope.lastSelected === doc) {
                $scope.lastSelected = null;
              }
            }
          } else {
            var docs = revisionListService.documents.filter($scope.itemsFilter);
            first = $scope.lastSelected;

            if (first) {
              aux = docs.indexOf(first);

              start = index > aux ? aux : index;
              end = index > aux ? index + 1 : aux;

              slice = docs.slice(start, end);
              slice.forEach((d) => {
                d.selected = true;
              });

              $scope.lastSelected = slice[slice.length - 1];
            } else {
              doc.selected = !doc.selected;

              if (doc.selected) {
                $scope.lastSelected = doc;
              } else if ($scope.lastSelected === doc) {
                $scope.lastSelected = null;
              }
            }
          }
        }

        if ($scope.isPreviewOpen)
          $scope.updatePreview();
      }

      function roadToFlow() {
        var linkActive =
          window.location.origin + '/#/workflow/run/' + $scope.rowGuid;
        window.open(linkActive);
      }

      function selectedDocuments() {
        $scope.countEntries += 1;

        if (
          $scope.groups !== undefined &&
          $scope.groups !== null &&
          $scope.groups.length > 0
        ) {
          var selectedItems = $scope.groups[0].items
            .filter($scope.itemsFilter)
            .filter((d) => d.selected === true);
          var more = $scope.groups[1].items
            .filter($scope.itemsFilter)
            .filter((d) => d.selected === true);

          more.forEach((r) => {
            selectedItems.push(r);
          });

          return selectedItems;
        } else {
          var isArray = Array.isArray(revisionListService.documents);
          if (
            revisionListService.documents === null ||
            revisionListService.documents.length === 0 ||
            !isArray
          )
            return [];

          var selected = revisionListService.documents
            .filter($scope.itemsFilter)
            .filter((d) => d.selected === true);
          return selected;
        }
      }

      function hasDocumentSelected() {
        return $scope.selectedDocuments().length > 0;
      }

      function canChangeProperties() {
        var docs = $scope.selectedDocuments();
        const isTemp = $rootScope.user && $rootScope.user.isTempUser;
        if (isTemp) return false;

        var doc = docs[0];
        if (doc !== undefined && doc.canProperties !== false) {
          return true;
        } else {
          return false;
        }
      }

      function updatePreview() {
        if ($scope.previewUrl) {
          URL.revokeObjectURL($scope.previewUrl);
          $scope.previewUrl = null;
        }

        $scope.previewLoading = true;
        $scope.previewUrl = null;
        $scope.previewDocument = null;
        $scope.dontPreviewDocument = false;
        $scope.errPreviewDocument = false;

        var selected = $scope.selectedDocuments();

        if (selected.length === 1) {
          $scope.dontPreviewDocument = false;

          if (selected[0].extension !== 'pdf') {
            $scope.previewDocument = null;
            $scope.previewUrl = null;
            $scope.previewLoading = false;
            $scope.dontPreviewDocument = true;
          } else {
            $scope.previewDocument = selected[0];
            $scope.previewLoading = true;

            let isDigitalization = false;

            if ($rootScope.selectedTreeItem !== null &&
              $rootScope.selectedTreeItem.TreeItemType === ETreeItemTypes.PENDING_SCAN) {
              isDigitalization = true;
            }

            let requestPreview = {
              Id: $scope.previewDocument.id,
              IdCompany: $scope.previewDocument.idCompany,
              Title: $scope.previewDocument.title,
              Extension: $scope.previewDocument.extension.toLowerCase(),
              IsDigitalization: isDigitalization
            };

            previewService.previewDocument(requestPreview)
              .then(function (res) {
                if (res.status === 204) {
                  $scope.previewUrl = null;
                  $scope.previewLoading = false;
                  $scope.dontPreviewDocument = true;
                  return;
                }

                var blob = new Blob([res.data], { type: 'application/pdf' });
                var url = URL.createObjectURL(blob);

                $scope.previewUrl = $sce.trustAsResourceUrl(url);

                $scope.previewLoading = false;
                $scope.dontPreviewDocument = false;
              })
              .catch(function () {
                $scope.previewLoading = false;
                $scope.dontPreviewDocument = false;
                $scope.errPreviewDocument = true;
              });
          }
        } else {
          $scope.previewDocument = null;
          $scope.previewUrl = null;
          $scope.previewLoading = false;
          $scope.dontPreviewDocument = false;
        }
      };

      function closePreview() {
        $scope.previewDocument = null;
        $scope.isPreviewOpen = false;

        $scope.updateColumnsForPreview();
      };

      function togglePreview() {
        $scope.isPreviewOpen = !$scope.isPreviewOpen;

        $scope.updateColumnsForPreview();

        if ($scope.isPreviewOpen) {
          $scope.updatePreview();
        } else {
          $scope.previewDocument = null;
          $scope.previewUrl = null;
        }
      };

      function canShowPreviewButton() {
        if ($rootScope.isOnlyOfficeEditing) return false;

        const { selectedTreeItem } = $rootScope;

        if (selectedTreeItem?.TreeItemType === ETreeItemTypes.PENDING_SCAN) {
          return ($scope.activeTab === 1 || $scope.activeTab === 2) && hasDocuments();
        }

        if (selectedTreeItem?.TreeItemType === ETreeItemTypes.FOLDER) {
          return hasDocuments();
        }

        return false;
      }

      function configColumns() {
        $scope.columns = [
          {
            id: 'icon',
            width: '3%',
            header: $filter('translate')('COLUMN.ICON'),
            expression: 'getIcon()',
            style: {
              margin: '0',
              padding: '4.0px',
              display: 'flex !important',
              'justify-content': 'center',
              'align-items': 'center',
              'text-overflow': 'clip',
              'max-width': '3px',
              'text-align': 'center !important',
            },
            hideHeader: true,
            visible: true,
            disabled: false,
            dataPriority: 1,
          },
          {
            id: 'status',
            width: '2.2%',
            header: $filter('translate')('COLUMN.STATUSICON'),
            expression: 'getStatusIcon()',
            style: {
              padding: '10px',
              'text-overflow': 'clip',
              'max-width': '20px',
              'text-align': 'left',
            },
            dataPriority: 1,
            hideHeader: true,
            visible: true,
            disabled: false,
          },
          {
            id: 'code',
            header: $filter('translate')('COLUMN.CODE'),
            style: {
              'min-width': '75px',
            },
            expression: 'code',
            sortExpression: 'code',
            mobileShow: false,
            dataPriority: 3,
            visible: false,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'title',
            width: $scope.isAutologin() ? '25%' : '30%',
            header: $filter('translate')('COLUMN.TITLE'),
            expression: 'formatedTitle()',
            style: {
              'min-width': '20px',
            },
            sortExpression: 'title',
            tooltip: 'tooltipTitle()',
            dataPriority: 1,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'description',
            header: $filter('translate')('COLUMN.DESCRIPTION'),
            expression: 'formatedDescription()',
            style: {
              'min-width': '150px',
              'max-width': '600px',
            },
            sortExpression: 'description',
            visible: false,
            dataPriority: $scope.isAutologin() ? 1 : 7,
            disabled: false,
            mobileShow: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'rev',
            header: $filter('translate')('COLUMN.REVNUMBER'),
            style: {
              'min-width': '20px',
            },
            width: '8%',
            expression: 'revisionNumber',
            visible: true,
            disabled: false,
            dataPriority: 3,
            mobileShow: false,
            sortable: true,
            type: 'number',
          },
          {
            id: 'author',
            header: $filter('translate')('COLUMN.AUTHOR'),
            expression: 'author.Name',
            style: {
              'min-width': '80px',
            },
            width: '10%',
            mobileShow: false,
            visible: true,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'folder',
            header: $filter('translate')('COLUMN.FOLDER'),
            width: '7%',
            expression: 'goToFolder()',
            sortExpression: 'folder.Name',
            mobileShow: false,
            visible: true,
            dataPriority: 3,
            sortable: true,
            disabled: true,
            type: 'text',
          },
          {
            id: 'document type',
            header: $filter('translate')('COLUMN.DOCTYPE'),
            expression: 'formatedDocumentType()',
            style: {
              'min-width': '120px',
            },
            width: '15%',
            dataPriority: 6,
            mobileShow: false,
            visible: true,
            disabled: false,
            sortable: true,
            type: 'text',
          },
          {
            id: 'date',
            header: $filter('translate')('COLUMN.DATE'),
            expression: 'formatedDate()',
            sortExpression: 'date',
            style: {
              'min-width': '85px',
            },
            width: '8%',
            mobileShow: false,
            visible: true,
            dataPriority: 5,
            disabled: false,
            sortable: true,
            type: 'date',
          },
          {
            id: 'documentDate',
            header: $filter('translate')('COLUMN.CREATION_DATE'),
            expression: 'formatedCreationDate()',
            sortExpression: 'documentDate',
            style: {
              'min-width': '85px',
            },
            mobileShow: false,
            visible: false,
            dataPriority: 5,
            disabled: false,
            sortable: true,
            type: 'date',
          },
          {
            id: 'size',
            header: $filter('translate')('COLUMN.SIZE'),
            expression: 'formatedSize()',
            sortExpression: 'size',
            style: {
              'min-width': '100px',
            },
            width: '10%',
            mobileShow: false,
            visible: true,
            dataPriority: 6,
            disabled: false,
            sortable: true,
            type: 'number',
          },
        ];

        if (authService.authentication.email === 'autologin') {
          var cont = 0;
          var columnsAutoLoginUser = [];
          var filterColumns = (c) => c.id === $scope.autologincolumns[cont];

          for (cont = 0; cont < $scope.autologincolumns.length; cont++) {
            var c = $scope.columns.filter(filterColumns)[0];
            if (c !== null) {
              c.disabled = false;
              c.visible = true;
              columnsAutoLoginUser.push(c);
            }
          }
          $scope.columns = columnsAutoLoginUser;
        }
      }

      $scope.updateColumnsForPreview = function () {
        if (!$scope.columns)
          return;

        var revColumn = $scope.columns.find(c => c.id === 'rev');
        var sizeColumn = $scope.columns.find(c => c.id === 'size');

        if ($scope.isPreviewOpen) {
          if (revColumn) revColumn.visible = false;
          if (sizeColumn) sizeColumn.visible = false;
        } else {
          if (revColumn) revColumn.visible = true;
          if (sizeColumn) sizeColumn.visible = true;
        }
      };

      function toggleColumn(column) {
        var toggle = !column.visible;
        var visibleColumns = $scope.getVisibleColumns();
        if (visibleColumns.length === 1 && toggle === false) return;
        column.visible = toggle;
      }

      function canSendFiles() {
        if ($rootScope.isOnlyOfficeEditing) return false;

        const isTemp = $rootScope.user && $rootScope.user.isTempUser;

        if (
          ($rootScope.selectedTreeItem &&
            $rootScope.selectedTreeItem.TreeItemType !== 1) ||
          isTemp
        )
          return false;

        if ($rootScope.user && $rootScope.user.isSysAdmin) return true;

        if ($rootScope.selectedTreeItem && $rootScope.selectedTreeItem.Features)
          return $rootScope.selectedTreeItem.Features.includes(
            EFeatures.SEND_DOCUMENT
          );
      }

      function selectorAct() {
        return (
          $scope.myWorkflowDeadLines !== undefined &&
          $scope.myWorkflowDeadLines !== null &&
          $scope.myWorkflowDeadLines.length > 0
        );
      }

      function selectorAll() {
        return (
          $scope.myWorkflowDeadLines !== undefined &&
          $scope.myWorkflowDeadLines !== null &&
          $scope.myWorkflowDeadLines.length > 0 &&
          $scope.myDeadLines !== undefined &&
          $scope.myDeadLines !== null &&
          $scope.myDeadLines.length > 0
        );
      }

      function hasDocuments() {
        if (
          $scope.groups !== undefined &&
          $scope.groups !== null &&
          $scope.groups.length > 0
        ) {
          var cont = 0;
          var hasDocs = false;
          while (cont < $scope.groups.length && hasDocs === false) {
            if ($scope.groups[cont].items.length > 0) hasDocs = true;
            cont++;
          }
          return hasDocs;
        } else {
          return (
            revisionListService.documents !== undefined &&
            revisionListService.documents !== null &&
            revisionListService.documents.length > 0
          );
        }
      }

      function sortColumn(column) {
        if (column.sortable !== true) return;

        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = (a, b) => sortOperation(a, b, column);

        if ($scope.groups.length > 0) {
          var sortRecursive = (g) => {
            if (g.items !== undefined && g.items.length > 0) g.items.sort(sort);
            if (g.groups !== undefined && g.groups.length > 0)
              g.group.forEach(sortRecursive);
          };

          $scope.groups.forEach(sortRecursive);
        } else {
          var isArray = Array.isArray(revisionListService.documents);
          if (isArray) revisionListService.documents.sort(sort);
        }
        var unsorted = $scope.columns.filter((c) => c.id !== column.id);
        unsorted.forEach((c) => {
          c.sorted = undefined;
        });
      }

      function isAutologin() {
        return authService.authentication.email === 'autologin';
      }

      function canLinkDocument() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        const isTemp = $rootScope.user && $rootScope.user.isTempUser;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0 || isTemp) return false;
        return docs.every((d) => d.canLinkDocument);
      }

      function hasLinkedDocuments(docs) {
        if (docs === undefined) docs = $scope.selectedDocuments();
        if (docs.length === 0 || docs.length > 1) return false;
        return docs.some((d) => d.hasLinkedDocuments);
      }

      function linkDocument() {
        var docs = $scope.selectedDocuments();

        if ($scope.hasLinkedDocuments(docs)) {
          swal.fire({
            title: $filter('translate')('DOCUMENT LINKED'),
            text: $filter('translate')('SELECTED DOCUMENT LINKED'),
            icon: 'info',
            showConfirmButton: true,
            confirmButtonText: $filter('translate')('OK'),
          });
        } else if (!$scope.canLinkDocument()) {
          swal.fire({
            title: $filter('translate')('NO PERMISSION'),
            text: $filter('translate')('NO LINK PERMISSION IN THIS DOCUMENT'),
            icon: 'info',
            showConfirmButton: true,
            confirmButtonText: $filter('translate')('OK'),
          });
        } else {
          $scope.linkService.isLinkingFiles = true;
          var ids = $scope.linkService.filesToLink.map((d) => d.id);
          var newones = docs.filter((d) => ids.indexOf(d.id) === -1);

          if (newones.length > 0) {
            if ($scope.linkService.filesToLink.length === 0)
              newones[0].isMainRevision = true;

            newones.forEach((n) => {
              $scope.linkService.filesToLink.push(n);
            });
          }

          $scope.isLinkingFiles = $scope.linkService.isLinkingFiles;
        }
      }

      function canCancelLinkedDocuments() {
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canCancelLinkDocument);
      }

      function cancelLinkedDocuments(id) {
        var docs = $scope.selectedDocuments();
        var ids = docs.map((d) => d.id);

        let cancelText;

        if (ids.length > 1) {
          cancelText = $filter('translate')('CONFIRM CANCEL LINK DOCUMENTS');
        } else {
          cancelText = $filter('translate')('CONFIRM CANCEL LINK DOCUMENT');
        }

        swal.fire({
          title: $filter('translate')('CANCEL LINK DOCUMENT'),
          text: cancelText,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: $filter('translate')('NO'),
          confirmButtonText: $filter('translate')('YES')
        }).then((result) => {
          if (result.isConfirmed) {
            $scope.linkService
              .cancel(id ? [id] : ids)
              .then(() => {
                $scope.clearLinkFilesVars();

                docs.forEach((d) => {
                  d.hasLinkedDocuments = false;
                });

                $state.reload();
              })
              .catch(() => {
                swal.fire({
                  title: $filter('translate')('AN ERROR OCCURRED'),
                  text: $filter('translate')('ERROR CANCEL LINK DOCUMENT'),
                  icon: 'error',
                  confirmButtonText: $filter('translate')('OK')
                });
              });
          }
        });
      }

      function resetMainDocumentLink() {
        for (var i = 0; i < $scope.linkService.filesToLink.length; i++) {
          $scope.linkService.filesToLink[i].isMainRevision = false;
        }
      }

      function canEditDocumentLink() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0 || docs.length > 1) return false;
        return docs[0].canEditDocumentLink;
      }

      function canAuditDocuments() {
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canAuditDocuments);
      }

      function editDocumentLink() {
        if ($scope.linkService.isLinkingFiles) {
          swal
            .fire({
              title: $filter('translate')(
                'CONFIRM CANCELING CHANGES DOCUMENT LINK TITLE'
              ),
              text: $filter('translate')(
                'CONFIRM CANCELING CHANGES DOCUMENT LINK'
              ),
              showCancelButton: true,
              cancelButtonText: $filter('translate')('NO'),
              confirmButtonText: $filter('translate')('YES'),
            })
            .then(function () {
              $scope.linkFileSelected = undefined;
              $scope.resetMainDocumentLink();
              $scope.linkService.reset();
              $scope.doEditDocumentLink();
            });
        } else {
          $scope.doEditDocumentLink();
        }
      }

      function doEditDocumentLink() {
        var current = $scope.selectedDocuments()[0];

        $scope.linkService.isLinkingFiles = true;
        $scope.showCancelLinkButton = false;
        $scope.linkService
          .loadLinkedDocuments(current.id)
          .then((links) => {
            if ($scope.linkService.isLinkingFiles) {
              $scope.linkService.filesToLink = links;
            } else {
              $scope.linkService.reset();
            }
          })
          .catch((data) => {
            $scope.showCancelLinkButton = true;
            swal.fire({
              title: data.error,
              text: data.error_description,
              icon: 'error',
            });
          });
      }

      function clearLinkFilesVars() {
        $scope.resetMainDocumentLink();
        $scope.linkService.reset();
        $scope.linkFileSelected = undefined;
        $scope.showCancelLinkButton = true;
        $scope.isLinkingFiles = false;
        $scope.linkService.isLinkingFiles = false;
      }

      function cancelLinkFiles() {
        $scope.linkFilesBool = true;

        $scope.messageTitle = $filter('translate')('CANCEL LINK DOCUMENT');
        $scope.messageDescription = $filter('translate')(
          linkFilesService.isEditingLinks()
            ? 'CONFIRM CANCEL LINK EDITION DOCUMENT'
            : 'CONFIRM CANCEL LINK DOCUMENT'
        );
        $scope.messageCancel = $filter('translate')('NO');
        $scope.messageForward = $filter('translate')('YES');

        $scope.modalQuestion = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'linkFileModalController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            revisions: () => $scope.docs,
          },
        });
      }

      function selectLinkFile(file) {
        $scope.linkFileSelected = file;
      }

      function changeMainLinkedDocument() {
        var doc = $scope.linkService.filesToLink.filter(
          (d) => d.isMainRevision
        );
        doc[0].isMainRevision = false;
        $scope.linkFileSelected.isMainRevision = true;

        var index = $scope.linkService.filesToLink.indexOf(
          $scope.linkFileSelected
        );
        $scope.linkService.filesToLink.splice(index, 1);
        $scope.linkService.filesToLink.unshift($scope.linkFileSelected);
      }

      function reorderLinkedFiles(fromIndex, toIndex) {
        var files = $scope.linkService.filesToLink;

        if (
          fromIndex < 0 ||
          toIndex < 0 ||
          fromIndex >= files.length ||
          toIndex >= files.length ||
          fromIndex === toIndex
        ) {
          return;
        }

        var draggedFile = files[fromIndex];
        var targetFile = files[toIndex];

        if (
          !draggedFile ||
          !targetFile ||
          draggedFile.isMainRevision ||
          targetFile.isMainRevision
        ) {
          return;
        }

        files.splice(fromIndex, 1);

        var destinationIndex =
          fromIndex < toIndex ? toIndex - 1 : toIndex;

        files.splice(destinationIndex, 0, draggedFile);
      }

      function moveLinkedFile(file, direction) {
        var files = $scope.linkService.filesToLink;
        var currentIndex = files.indexOf(file);
        var targetIndex = currentIndex + direction;

        if (
          currentIndex <= 0 ||
          targetIndex <= 0 ||
          targetIndex >= files.length
        ) {
          return;
        }

        files.splice(currentIndex, 1);
        files.splice(targetIndex, 0, file);

        $scope.linkFileSelected = file;
      }

      function removeFromLink() {
        if (
          $scope.linkService.originalList &&
          $scope.linkService.originalList.length > 0 &&
          $scope.linkService.filesToLink.length === 1
        ) {
          $scope.cancelLinkedDocuments($scope.linkService.originalList[0].id);
          return;
        }

        var index = $scope.linkService.filesToLink.indexOf(
          $scope.linkFileSelected
        );

        var doc = revisionListService.documents.filter(
          (d) => d.id === $scope.linkFileSelected.id
        );
        if (doc && doc.length > 0) {
          doc[0].hasLinkedDocuments = false;
          doc[0].canLinkDocument = true;
          doc[0].canCancelLinkDocument = false;
        }

        if (index >= 0) {
          $scope.linkService.filesToLink.splice(index, 1);
        }

        if ($scope.linkService.filesToLink.length === 0) {
          $scope.linkService.isLinkingFiles = false;
          $scope.isLinkingFiles = $scope.linkService.isLinkingFiles;
        } else {
          if ($scope.linkFileSelected.isMainRevision) {
            $scope.linkService.filesToLink[0].isMainRevision = true;
            doc[0].isMainRevision = false;
          }
        }

        var length = $scope.linkService.filesToLink.length;
        $scope.linkFileSelected =
          length > 0 ? $scope.linkService.filesToLink[length - 1] : undefined;
      }

      function countLinks() {
        return $scope.linkService.filesToLink.length;
      }

      function isLoadingLinks() {
        $scope.countLinks() === 0 || $scope.linkService.originalList === null;
      }

      function updateDocs(doc, bool) {
        if (doc && doc.length > 0) {
          doc[0].hasLinkedDocuments = bool;
          doc[0].canLinkDocument = !bool;
          doc[0].canCancelLinkDocument = bool;
          doc[0].canEditDocumentLink = bool;
        }
      }

      function doLinkFiles() {
        if ($scope.linkService.filesToLink.length > 1) {
          swal.fire({
            title: $filter('translate')('WAIT LINKING DOCUMENTS'),
            icon: 'info',
            showConfirmButton: false,
            showCancelButton: false,
          });
          $scope.linkService
            .save()
            .then(() => {
              var ids = [];
              $scope.linkService.filesToLink.forEach((f) => {
                ids.push(f.id);
                var doc = revisionListService.documents.filter(
                  (d) => d.id === f.id
                );
                $scope.updateDocs(doc, true);
              });

              var removeds = $scope.linkService.originalList.filter(
                (el) => ids.indexOf(el.id) < 0
              );
              removeds.forEach((r) => {
                var doc = revisionListService.documents.filter(
                  (d) => d.id === r.id
                );
                $scope.updateDocs(doc, false);
              });

              $scope.clearLinkFilesVars();
              swal.close();
            })
            .catch((data) => {
              swal.fire({
                title: data.error,
                text: data.error_description,
                icon: 'error',
              });
            });
        } else {
          swal.fire({
            title: $filter('translate')('SELECT MORE DOCUMENTS'),
            text: $filter('translate')('SELECT MORE DOCUMENTS TO LINK'),
            icon: 'info',
            showConfirmButton: true,
            confirmButtonText: $filter('translate')('OK'),
          });
        }
      }

      function getVisibleColumns() {
        var width = $window.innerWidth;
        var maxPriority = Math.floor(width / 160);
        return $scope.columns.filter(
          (c) => c.visible && !c.disabled && c.dataPriority < maxPriority
        );
      }

      function getClass(index) {
        var colors = [
          'teal',
          'green',
          'orange',
          'lightgreen',
          'bluegray',
          'brown',
          'red',
        ];
        var i =
          index + 1 >= colors.length
            ? (colors.length % (index + 1)) - 1
            : index;
        return 'bgm-' + colors[i];
      }

      function getDescription(currentPage, pageSize, count, displayed) {
        if (!count) count = 0;

        var final = displayed !== null && displayed !== undefined
          ? Number(displayed)
          : (Number(currentPage) * Number(pageSize) || 0);

        final = Math.min(final, count);

        return String.format(
          $filter('translate')('SHOWING X OF Y DOCUMENTS'),
          final,
          count
        );
      }

      function newCheckin(item) {
        var current = $scope.selectedDocuments()[0];

        item.currentDocument = current;
        item.revision = new uploadRevision(item);
        if (current.titleOriginal) {
          item.revision.Title = current.titleOriginal;
        }
        if (current.descriptionOriginal) {
          item.revision.Description = current.descriptionOriginal;
        }
        folderService.load(item.revision.IdFolder, true).then((c) => {
          c.name = c.Name;
          c.TreeItemType = c.TreeItemType === null ? 1 : c.TreeItemType;
          c.HasPermission = c.HasPermission === null ? true : c.TreeItemType;
          c.toString = () => this.name;

          item.revision.folder(c);
        });
      }

      function isTrashCanHelp() {
        var location = window.location.hash;
        if (location === '#/trashcan/1') {
          return 1;
        } else {
          return 0;
        }
      }

      function canReplace() {
        let docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;

        return authService.getLoggedCompany().IsAdmin && docs.length === 1;
      }

      function canReplaceFileSigned() {
        if ($rootScope.isOnlyOfficeEditing)
          return true;

        var docs = $scope.selectedDocuments();

        if (docs[0] !== undefined) {
          if (docs[0].canReplaceFile === true) {
            if (docs[0].canDownload === true) {
              if (docs[0].isSigned === true && docs[0].idStatus === 1) {
                return true;
              } else if (docs[0].idStatus === 8) {
                return docs[0].idStatus;
              } else if (docs[0].idStatus === 3) {
                return docs[0].idStatus;
              } else if (docs[0].idStatus === 4) {
                return docs[0].idStatus;
              } else {
                return false;
              }
            }
          }
        }
      }

      function canReplaceFile() {
        if ($rootScope.isOnlyOfficeEditing)
          return false;

        var docs = $scope.selectedDocuments();

        if (docs[0] !== undefined) {
          if ($rootScope.selectedTreeItem !== null) {
            if (
              $rootScope.selectedTreeItem.Features.includes(
                EFeatures.REPLACE_FILE
              ) === true
            ) {
              if (
                docs.length > 0 &&
                !docs[0].isSigned &&
                ![3, 4, 5, 8].includes(docs[0].idStatus)
              ) {
                return true;
              } else {
                return false;
              }
            }
          }
        }
      }

      function replaceFile() {
        var current = $scope.selectedDocuments()[0];
        var uploader = $scope.replaceUploader;
        $scope.goToMyDocuments();

        uploader.queue.forEach((item) => (item.revision.uploading = true));

        uploader.onBeforeUploadItem = function (item) {
          var authData = authService.authentication;
          var isauth = authData.token !== null && authData.token !== '';
          var keywords = Array.isArray(item.revision.Keywords)
            ? item.revision.Keywords.join(';')
            : null;

          var rev = {
            Id: item.revision.Id,
            IdFolder: item.revision.IdFolder,
            IdDocumentType: item.revision.IdDocumentType,
            RevisionNumber: current.revisionNumber,
            Code: current.code,
            Date: current.date,
            Title: item.revision.Title,
            Description: item.revision.Description,
            Keywords: keywords,
            Extension: item.revision.Extension,
            Size: item.revision.Size,
            DocumentDate: item.revision.DocumentDate,
            RevisionAdditionalFields: [],
            AdditionalFields: [],
            NextRevisionDate:
              item.revision.NextRevisionDate !== undefined
                ? item.revision.NextRevisionDate
                : null,
            NotificationDays:
              item.revision.NotificationDays !== undefined &&
                item.revision.NotificationDays !== 0
                ? item.revision.NotificationDays
                : null,
          };

          for (
            var i = 0;
            i < item.revision.RevisionAdditionalFields.length;
            i++
          ) {
            var a = item.revision.RevisionAdditionalFields[i];

            rev.RevisionAdditionalFields.push({
              IdAdditionalField: a.id,
              Value: a.value,
            });
          }

          item.formData = [
            {
              revision: angular.toJson(rev),
            },
          ];

          if (item.revision.IdWorkflow) {
            item.formData.push({
              workflow: item.revision.IdWorkflow,
            });
            item.formData.push({
              isCheckinFromFlowTask: false,
            });
          }

          item.headers = {
            Authorization: isauth ? 'Bearer ' + authData.token : '',
          };
        };

        uploader.onCompleteAll = function () {
          var error = uploader.queue.filter(function (e) {
            return e.isError;
          });
          if (error.length === 0) {
            uploader.clearQueue();
            $state.reload();
            $rootScope.$broadcast('toogleSidebar', false);
          }
        };
        uploader.uploadAll();
        $timeout(function () {
          $rootScope.$broadcast('toogleSidebar', true);
        }, 500);
      }

      function checkinFiles() {
        if ($scope.modalOpen === true) return;

        var current = $scope.selectedDocuments()[0];

        $scope.modalOpen = true;

        var uploaderInstance = $scope.checkinUploader;

        var modal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/sendFiles.html',
          controller: 'sendFilesController',
          backdrop: 'static',
          keyboard: true,
          size: 'lg',
          resolve: {
            uploader: () => uploaderInstance,
            revisionCheckin: () => current,
          },
        });

        modal.result
          .then((uploader) => {
            $scope.goToMyDocuments();

            uploader.queue.forEach((item) => (item.revision.uploading = true));

            uploader.onBeforeUploadItem = (item) => {
              var authData = authService.authentication;
              var isauth = authData.token !== null && authData.token !== '';
              var keywords = Array.isArray(item.revision.Keywords)
                ? item.revision.Keywords.join(';')
                : null;
              var rev = {
                Id: item.revision.Id,
                IdFolder: item.revision.IdFolder,
                IdDocumentType: item.revision.IdDocumentType,
                Title: item.revision.Title,
                Description: item.revision.Description,
                Keywords: keywords,
                Extension: item.revision.Extension,
                Size: item.revision.Size,
                DocumentDate: item.revision.DocumentDate,
                RevisionAdditionalFields: [],
                NextRevisionDate:
                  item.revision.NextRevisionDate !== undefined
                    ? item.revision.NextRevisionDate
                    : null,
                NotificationDays:
                  item.revision.NotificationDays !== undefined &&
                    item.revision.NotificationDays !== 0
                    ? item.revision.NotificationDays
                    : null,
              };

              for (
                var i = 0;
                i < item.revision.RevisionAdditionalFields.length;
                i++
              ) {
                var a = item.revision.RevisionAdditionalFields[i];

                rev.RevisionAdditionalFields.push({
                  IdAdditionalField: a.id,
                  Value: a.value,
                });
              }

              item.formData = [
                {
                  revision: angular.toJson(rev),
                },
              ];

              if (item.revision.IdWorkflow) {
                item.formData.push({
                  workflow: item.revision.IdWorkflow,
                });
                item.formData.push({
                  isCheckinFromFlowTask: false,
                });
              }

              item.headers = {
                Authorization: isauth ? 'Bearer ' + authData.token : '',
              };
            };

            uploader.onCompleteAll = () => {
              var toD4Sign = uploader.queue.filter(function (f) {
                return f.revision.id !== 0 && f.signDocumentD4s === true;
              });

              var toSign = uploader.queue.filter(function (f) {
                return (
                  f.revision.id !== 0 &&
                  f.signDocument === true &&
                  f.signing !== true
                );
              });

              if (toD4Sign.length > 0) {
                var revisions = new Array();
                revisions.push(toD4Sign[0].revision);
                var d4SignModal = uibModal.open({
                  scope: $scope,
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modules/signing/signDocumentD4s.html',
                  controller: 'signDocumentsD4sController',
                  resolve: {
                    revisions: () => revisions,
                  },
                });

                d4SignModal.result.then(function () {
                  var error = uploader.queue.filter(function (e) {
                    return e.isError;
                  });
                  if (error.length === 0) {
                    var anyInCurrentFolder = uploader.queue.some(function (s) {
                      return s.revision.IdFolder + '' === $state.params.id;
                    });
                    if (anyInCurrentFolder) {
                      $state.reload();
                    }
                    $rootScope.$broadcast('toogleSidebar', false);
                    return;
                  }
                });
              }

              if (toSign.length > 0) {
                var revisions = [];

                for (var i = 0, len = toSign.length; i < len; i++) {
                  toSign[i].signing = true;
                  revisions.push(toSign[i].revision);
                }

                var signModal = uibModal.open({
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl:
                    '/views/modules/signing/signDocumentPartial.html',
                  controller: 'signDocumentsController',
                  windowClass: 'sign-modal-window',
                  resolve: {
                    revisions: function () {
                      return revisions;
                    },
                    sealData: function () {
                      return "";
                    },
                  },
                });

                signModal.result.then(function () {
                  var error = uploader.queue.filter(function (e) {
                    return e.isError;
                  });
                  if (error.length === 0) {
                    uploader.queue.every(function (s) {
                      return s.revision.IdWorkflow ? true : false;
                    });
                    var anyInCurrentFolder = uploader.queue.some(function (s) {
                      return s.revision.IdFolder + '' === $state.params.id;
                    });
                    if (anyInCurrentFolder) {
                      $state.reload();
                    }
                    uploader.clearQueue();
                    $rootScope.$broadcast('toogleSidebar', false);
                  }
                });
              }

              var error = uploader.queue.filter((e) => e.isError);
              if (error.length === 0) {
                uploader.clearQueue();
                $state.reload();
                $rootScope.$broadcast('toogleSidebar', false);
              }
            };

            uploader.uploadAll();

            $scope.modalOpen = false;

            $timeout(() => {
              $rootScope.$broadcast('toogleSidebar', true);
            }, 500);
          })
          .catch(() => {
            var filter = $scope.checkinUploader.queue.filter(
              (item) => item.isUploading === false
            );

            filter.forEach((item) => {
              $scope.checkinUploader.removeFromQueue(item);
            });

            $scope.modalOpen = false;
          });
      }

      function canMove() {
        return false;
      }

      function canShareDocuments() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canShare);
      }

      function canPublicLink() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        return docs.length === 1 ? docs[0].canPublicLink : false;
      }

      function canConvertToPdf() {
        if (webApiSettings.detailsCompany === 'abase')
          return false;

        var docs = $scope.selectedDocuments();

        if (docs.length === 1) {
          return docs[0].canConvertToPdf && docs[0].idStatus === 1;
        }
        return false;
      }

      function canSendByEmail() {
        const isTemp = $rootScope.user && $rootScope.user.isTempUser;

        if (isTemp || webApiSettings.detailsCompany === 'abase')
          return false;

        if (!$scope.checkCanSendByEmail) {
          $scope.valueCanSendByEmail = false;
          $scope.checkCanSendByEmail = true;

          let canSendByEmail = false;

          roleCrudService.list().then((roles) => {
            roles.forEach((role) => {
              if (!canSendByEmail) {
                canSendByEmail = role.RolesFeaturesList.some(
                  (w) => w.id === 12
                ); // EFeatures.SEND_BY_EMAIL
              }
            });

            $scope.valueCanSendByEmail = canSendByEmail;
          });
        }

        return $scope.valueCanSendByEmail;
      }

      function shareDocuments() {
        var modal = uibModal.open({
          animation: true,
          templateUrl: 'views/documents/share/modal.html',
          controller: 'shareDocumentsController',
          backdrop: 'static',
          keyboard: true,
          size: 'md',
          resolve: {
            revisions: () => $scope.selectedDocuments(),
          },
        });

        modal.result.then(() => { }).catch(() => { });
      }

      function canViewDocument() {
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;

        var isViewDoc = docs.every((d) => d.canView);
        var isViewMovie = docs.every((d) => d.canMovie);

        if (isViewMovie) {
          docs.every((d) => (d.canView = true));
        }

        return isViewDoc || isViewMovie;
      }

      function hasViewPermission() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.hasViewPermission);
      }

      function saveDocumentLog() {
        var docs = $scope.selectedDocuments();
        var ids = docs.map((r) => r.id);

        var filter = {};

        filter.NoDate = true;
        filter.dateFilterType = 0;
        filter.EmptyLogType = true;
        filter.reportType = 11;
        filter.IdRevision = ids[0];

        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });

        $scope.filter = filter;

        dashboardService
          .generateauditDocumentReport($scope.filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          });
      }

      function properties() {
        var docs = $scope.selectedDocuments();
        if (docs.length === 1) {
          docs[0].properties();

          if (docs[0].isDigitalization) {
            $scope.$broadcast('STOP_AUTO_REFRESH');
          }
        }
      }

      function hasLinkedDocuments() {
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.some((d) => d.hasLinkedDocuments);
      }

      function view(doc) {
        if ($state.current.name === 'home.trashcan') return;
        var docs = doc ? [doc] : $scope.selectedDocuments();
        var cantViewOnBrowser;
        if (doc) {
          cantViewOnBrowser = !doc.canView;
          doc.selected = true;
        } else {
          cantViewOnBrowser = !$scope.canViewDocument();
        }

        if (cantViewOnBrowser) {
          if ($scope.hasViewPermission() === true) {
            var canDownload = $scope.canDownload === true;

            var msg = canDownload
              ? $filter('translate')('DOWNLOAD TO VIEW')
              : $filter('translate')('VIEW NOT SUPPORTED');

            swal
              .fire({
                title: $filter('translate')('VIEWER NOT AVAILABLE'),
                text: msg,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'OK',
                cancelButtonColor: '#ABABAB',
                confirmButtonText: $filter('translate')('DO DOWNLOAD'),
                showConfirmButton: canDownload,
                confirmButtonColor: '#4285F4',
              })
              .then((download) => {
                if (download) $scope.download();
              });
          }
          return;
        }
        if ($scope.hasLinkedDocuments()) {
          var ids = docs.map((r) => r.id);

          revisionListService
            .loadLinkedDocuments(ids)
            .then((linked) => {
              var modal = uibModal.open({
                animationEnabled: true,
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/views/partials/viewLinkedDocs.html',
                controller: 'linkedDocumentsController',
                resolve: {
                  docs: () => linked,
                },
              });

              modal.result.then(() => {
                var docSelected = linked.filter((d) => d.selected === true);

                $scope.viewDoc(docSelected);
              });
            })
            .catch(() => { });
          return;
        }

        $scope.viewDoc(docs);
      }

      function extractSearch(revision) {
        try {
          // Regular expression to match the text inside <strong> tags
          let html = revision.highlightFields.all;

          // Find the content after <small>Encontrado no Conteúdo:</small>
          let contentStartIndex = html.indexOf('<small>Encontrado no Conteúdo:</small>') + '<small>Encontrado no Conteúdo:</small>'.length;

          // Slice the HTML string from that point onward
          let contentAfterEncontrado = html.slice(contentStartIndex);

          // Extract all the <strong> tags in the remaining HTML
          let matches = contentAfterEncontrado.match(/<strong>(.*?)<\/strong>/g);

          // Clean up the matches, remove the <strong> tags, and join them
          if (matches) {
            let extractedText = matches
              .map(match => match.replace(/<strong>|<\/strong>/g, ''))
              .join(' ');

            return extractedText;
          }

          // Return an empty string if no match is found
          return '';
        } catch {
          // Return an empty string in case of an error
          return '';
        }
      }

      async function viewDoc(docs) {
        for (var i = 0, len = docs.length; i < len; i++) {
          var docStatus = docs[i].idStatus;
          var url = '';
          var revision = docs[i];

          let title = revision.title
            .toString()
            .replace(/<mark><strong>/g, '')
            .replace(/<\/strong><\/mark>/g, '');

          revision.title = title;

          var dataUri = {
            revision: {
              id: revision.id,
              idCompany: revision.idCompany,
              isHistory: revision.isHistory,
              extension: revision.extension.toLowerCase(),
              title: revision.title,
              server: webApiSettings.viewerServer,
              rowGuid: revision.guid,
              pageCount: revision.numberOfPages,
              userId: authService.user.id
            },
            token: authService.authentication.token,
            webApiUrl: webApiSettings.apiServiceBaseUri,
            detailsCompany: webApiSettings.detailsCompany,
            infos: {
              canPrint: revision.canDownload,
              canDownload: revision.canDownload,
              urlBase: window.location.href,
            },
            signers: [],
            search: $scope.extractSearch(revision),
          };

          var signers = [];
          if (revision.isSigned) {
            revisionListService
              .loadSignersInfo(
                !revision.isHistory ? revision.id : revision.idRevisionHistory,
                revision.extension,
                revision.hasWorkflow,
                revision.isHistory
              )
              .then((infoSigners) => {
                signers = infoSigners;
              })
              .catch(() => { })
              .finally(function () {
                dataUri['signers'] = signers;

                if (docStatus === 3) {
                  if (revision.idRevisionHistory !== undefined) {
                    dataUri.revision.isOldRevision = true;
                    dataUri.revision.id = revision.idRevisionHistory;
                  }
                  var encoded = encodeURIComponent(JSON.stringify(dataUri));
                  url = webApiSettings.viewerBaseUri + '#/' + encoded;
                } else {
                  var encoded = encodeURIComponent(JSON.stringify(dataUri));
                  url = webApiSettings.viewerBaseUri + '#/' + encoded;
                }

                $scope.openView(url);
              });
          } else {
            if (docStatus === 3) {
              if (docs[i].idRevisionHistory !== undefined) {
                dataUri.revision.isOldRevision = true;
                dataUri.revision.id = docs[i].idRevisionHistory;
              }
              var encoded = encodeURIComponent(JSON.stringify(dataUri));

              url = webApiSettings.viewerBaseUri + '#/' + encoded;
            } else {
              var encoded = encodeURIComponent(JSON.stringify(dataUri));
              url = webApiSettings.viewerBaseUri + '#/' + encoded;
            }

            $scope.openView(url);
          }
        }
      }

      function openView(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }

      function canDownload(docSelected) {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = docSelected ? docSelected : $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canDownload);
      }

      function download(inWorkflow, docSelected) {
        var docs;

        if (docSelected) {
          docs = docSelected;
        } else {
          docs = $scope.selectedDocuments();
        }

        if (inWorkflow !== null) {
          if (!$scope.canDownload(docs) && !inWorkflow) return false;
        } else {
          if (!$scope.canDownload() && !inWorkflow) return false;
        }

        if (docs.length > 1) {
          var ids = docs.map((d) => d.id);

          toastr.options = {
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            positionClass: 'toast-bottom-right',
            showDuration: '1000',
            hideDuration: '1000',
            timeOut: '7000',
            extendedTimeOut: '1000',
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut',
          };
          toastr['info']($filter('translate')('PREPARING FILES TO DOWNLOAD'));

          revisionListService
            .downloadMulti(ids)
            .then(() => { })
            .catch(() => { });
        } else {
          var doc = docs[0];
          var idDownload =
            (doc.isPublic || inWorkflow) && doc.guid !== undefined
              ? doc.guid
              : doc.id;

          revisionListService
            .download(idDownload, doc.isPublic, inWorkflow, doc.isDigitalization)
            .then(() => { })
            .catch(() => { });
        }
      }

      function canOnlyOffice(docSelected) {
        if (webApiSettings.viewerServer === 'H5PROD') {
          return false;
        }

        const isTemp = $rootScope.user && $rootScope.user.isTempUser;
        if (isTemp || $scope.isAutologin()) {
          return false;
        }

        var docs = docSelected ? docSelected : $scope.selectedDocuments();

        if (docs.length !== 1) {
          return false;
        }

        var revision = docs[0];

        if (revision.isDigitalization !== undefined && revision.isDigitalization === true) {
          return false;
        }

        if (revision.revisionCheckout != null) {
          if (!revision.revisionCheckout.Resolved && revision.revisionCheckout.IdUser !== authService.user.id) {
            return false;
          }
        }

        if (
          revision.certificataDocument &&
          revision.certificataDocument.length > 0
        ) {
          return !revision.certificataDocument.every(function (cert) {
            return cert.RevisionNumber === revision.revisionNumber;
          });
        }

        return true;
      }

      function onlyOffice(docSelected) {
        const isEditing = $rootScope.isOnlyOfficeEditing;
        $rootScope.isOnlyOfficeEditing = !isEditing;

        if (!isEditing) {
          const docs = docSelected ? [docSelected] : $scope.selectedDocuments();
          if (!docs || docs.length === 0) return;

          const doc = docs[0];

          $rootScope.onlyOfficeCurrentDocument = doc;

          revisionListService
            .doCheckoutOnlyOffice(doc)
            .then(function () {
              return onlyOfficeService.getConfig(doc.id);
            })
            .then(function (config) {
              setupOnlyOffice(config);

              if (window.onlyOfficeEditor) {
                window.onlyOfficeEditor.destroyEditor();
                window.onlyOfficeEditor = null;
              }

              window.onlyOfficeEditor = new DocsAPI.DocEditor("placeholder", config);

              $rootScope.isOnlyOfficeEditing = true;
              updateShowBar(true);

              if (doc.isExpired && doc.isExpired()) {
                openExpiredModalForOnlyOffice(doc);
              }
            })
            .catch(function (error) {
              swal.fire({
                title: error && error.error,
                text: error && error.error_description,
                icon: "error"
              });

              $rootScope.isOnlyOfficeEditing = false;
              updateShowBar(false);
            });
        }
      }

      function openExpiredModalForOnlyOffice(doc) {
        var modalInstance = uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          keyboard: false,
          templateUrl: '/views/modal/expiredDocumentModal/expiredDocumentModal.html',
          controller: 'expiredDocumentModalController',
          size: 'md',
          windowClass: 'modal-expired-document',
          resolve: {
            revision: () => doc
          }
        });

        modalInstance.result
          .then(function (updated) {
            if (updated) {
            }
          })
          .catch(function () {
            exitOnlyOfficeEditing();
          });
      }

      function updateShowBar(status) {
        $rootScope.showSidebar = status;
      }

      function setupOnlyOffice(config) {
        var isEditable =
          config.editorConfig &&
          config.editorConfig.mode === "edit" &&
          config.document &&
          config.document.permissions &&
          config.document.permissions.edit === true;

        $rootScope.onlyOfficeIsEditable = isEditable;

        if (!isEditable) {
          swal.fire({
            title: $filter('translate')("READONLY DOCUMENT"),
            text: $filter('translate')("READONLY DOCUMENT MESSAGE"),
            icon: "warning"
          });
        }

        config.events = config.events || {};

        config.events.onAppReady = function () {
        };

        config.events.onDocumentReady = function () {
          $scope.$applyAsync(function () {
            $rootScope.onlyOfficeIsReady = true;
            $rootScope.onlyOfficeHasChanges = false;
            $rootScope.onlyOfficeWasSaved = false;
          });
        };

        config.events.onDocumentStateChange = function (event) {
          $scope.$applyAsync(function () {
            $rootScope.onlyOfficeHasChanges = event.data;
            if (!event.data) {
              $rootScope.onlyOfficeWasSaved = true;
            }
          });
        };

        config.events.onInfo = function (event) {
        };

        config.events.onError = function (event) {
          swal.fire({
            title: $filter('translate')("ERROR"),
            text: $filter('translate')("ERROR MESSAGE EDITION"),
            icon: "error"
          });
        };

        config.events.onRequestEditRights = function () {
          swal.fire({
            title: $filter('translate')("REQUEST EDIT RIGHTS"),
            text: $filter('translate')("REQUEST EDIT RIGHTS MESSAGE"),
            icon: "info"
          });
        };

        config.events.onRequestClose = function () {
          exitOnlyOfficeEditing();
        };
      }

      function exitOnlyOfficeEditing() {
        if (!$rootScope.onlyOfficeIsEditable) {
          cancelCheckoutAndClose();
          return;
        }

        if ($rootScope.onlyOfficeHasChanges) {
          swal.fire({
            title: $filter('translate')("EXISTING CHANGES"),
            html: $filter('translate')("EXISTING CHANGES MESSAGE"),
            icon: "warning",
            width: 500,
            showCancelButton: true,
            confirmButtonText: $filter('translate')("EXIT EDITION"),
            cancelButtonText: $filter('translate')("CONTINUE EDITING"),
            confirmButtonColor: "#f0ad4e",
            reverseButtons: true,
            focusCancel: true,
            customClass: {
              htmlContainer: 'swal-text-left',
              cancelButton: 'swal-cancel-outline'
            }
          }).then(function (result) {
            if (result.isConfirmed) {
              cancelCheckoutAndClose();
            }
          });

          return;
        }

        var doc = $rootScope.onlyOfficeCurrentDocument;
        closeOnlyOffice();
        hideEditorAndSync(doc);
      }

      function cancelCheckoutAndClose() {
        var doc = $rootScope.onlyOfficeCurrentDocument;
        var ids = doc ? [doc.id] : [];

        revisionListService.cancelCheckout(ids)
          .then(function () {
            if (doc) {
              doc.revisionCheckout = null;
              doc.idStatus = 1;
              doc.updatePermissions();
            }
            finishCancelAndClose();
          })
          .catch(function (err) {
            swal.insertQueueStep({
              title: err.error,
              text: err.errorDescription,
              icon: 'error',
            });
            finishCancelAndClose();
          });
      }

      function finishCancelAndClose() {
        if (window.onlyOfficeEditor) {
          try {
            window.onlyOfficeEditor.destroyEditor();
          } catch (e) {
            console.error("[OnlyOffice] Erro ao destruir editor.", e);
          }
          window.onlyOfficeEditor = null;
        }

        $rootScope.onlyOfficeIsReady = false;
        $rootScope.onlyOfficeHasChanges = false;
        $rootScope.onlyOfficeWasSaved = false;
        $rootScope.isOnlyOfficeEditing = false;
        $rootScope.onlyOfficeCurrentDocument = null;

        updateShowBar(false);
        document.getElementById("placeholder").innerHTML = "";

        $rootScope.$applyAsync(function () {
          if (!revisionListService.documents || revisionListService.documents.length === 0) {
            $state.reload();
          }
        });
      }

      function hideEditorAndSync(doc) {
        if (window.onlyOfficeEditor) {
          try {
            window.onlyOfficeEditor.destroyEditor();
          } catch (e) {
            console.error("[OnlyOffice] Erro ao destruir editor.", e);
          }
          window.onlyOfficeEditor = null;
        }

        $rootScope.isSyncingAfterEdit = true;
        $rootScope.onlyOfficeIsReady = false;
        $rootScope.onlyOfficeHasChanges = false;
        $rootScope.isOnlyOfficeEditing = false;

        updateShowBar(false);
        document.getElementById("placeholder").innerHTML = "";

        if (!doc) {
          $scope.$applyAsync(function () {
            $rootScope.isSyncingAfterEdit = false;
          });
          return;
        }

        pollRevisionStatus(doc, 0, function () {
          $rootScope.$applyAsync(function () {
            $rootScope.isSyncingAfterEdit = false;
            $rootScope.onlyOfficeCurrentDocument = null;

            if (!revisionListService.documents || revisionListService.documents.length === 0) {
              $state.reload();
            }
          });
        });
      }

      function pollRevisionStatus(doc, attempt, onDone) {
        var maxAttempts = 30;
        var intervalMs = 2000;

        revisionListService.getRevisionStatus(doc.id)
          .then(function (revision) {
            var finished = !revision.IsCheckedOut || attempt >= maxAttempts;

            if (finished) {
              $rootScope.$applyAsync(function () {
                doc.idStatus = revision.IdStatus;
                doc.revisionNumber = revision.RevisionNumber;
                doc.updatePermissions();
              });
              onDone();
              return;
            }

            $timeout(function () {
              pollRevisionStatus(doc, attempt + 1, onDone);
            }, intervalMs);
          })
          .catch(function (err) {
            console.error("[OnlyOffice] Erro ao obter status da revisão.", err);
            onDone();
          });
      }

      function finishClose() {
        if (window.onlyOfficeEditor) {
          try {
            window.onlyOfficeEditor.destroyEditor();
          }
          catch (e) {
            console.error("[OnlyOffice] Erro ao destruir editor.", e);
          }

          window.onlyOfficeEditor = null;
        }

        $rootScope.onlyOfficeIsReady = false;
        $rootScope.onlyOfficeHasChanges = false;
        $rootScope.onlyOfficeWasSaved = false;
        $rootScope.isOnlyOfficeEditing = false;
        $rootScope.onlyOfficeCurrentDocument = null;

        updateShowBar(false);
        document.getElementById("placeholder").innerHTML = "";
      }

      function closeOnlyOffice() {
        if (
          !$rootScope.onlyOfficeHasChanges &&
          !$rootScope.onlyOfficeWasSaved
        ) {
          revisionListService
            .cancelCheckout($rootScope.onlyOfficeCurrentDocument.id)
            .finally(finishClose);

          return;
        }

        if ($rootScope.onlyOfficeHasChanges) {
          revisionListService
            .cancelCheckout($rootScope.onlyOfficeCurrentDocument.id)
            .finally(finishClose);

          return;
        }

        if ($rootScope.onlyOfficeWasSaved) {
          finishClose();
        }
      }

      function canDownloadDigitray() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        const { selectedTreeItem } = $rootScope;
        const validTypes = [ETreeItemTypes.PENDING_SCAN];
        return validTypes.includes(selectedTreeItem?.TreeItemType);
      }

      function downloadDigitray() {
        digitalizationService.downloadDigitray()
          .then(() => { })
          .catch(() => { });
      }

      function canCheckin() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0 || docs.length > 1) return false;
        return docs[0].canCheckin;
      }

      function canCheckout() {
        if ($rootScope.isOnlyOfficeEditing)
          return false;

        var docs = $scope.selectedDocuments();
        const isTemp = $rootScope.user && $rootScope.user.isTempUser;
        if (docs.length === 0
          || docs.length > 1
          || isTemp)
          return false;

        return docs[0].canCheckout;
      }

      function checkout() {
        if (!$scope.canCheckout) {
          swal.fire($filter('translate')('NO CHECKOUT PERMISSION'));
          return;
        }

        var currentDocument = $scope.selectedDocuments()[0];

        var alreadyInCheckout = currentDocument.idStatus === 5;

        if (alreadyInCheckout) {
          swal.fire({
            title: $filter('translate')('DOCUMENT ALREADY IN CHECKOUT'),
            text: $filter('translate')('CONFIRM REPLACE CHECKOUT'),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: $filter('translate')('NO'),
            confirmButtonText: $filter('translate')('YES'),
            showLoaderOnConfirm: true,
            preConfirm: () => {
              return new Promise((resolve) => {
                revisionListService.doCheckout(currentDocument);
                resolve();
              });
            },
            allowOutsideClick: false,
          });
        } else {
          revisionListService.doCheckout(currentDocument);
        }
      }

      function canCertificataInsertCredential() {
        var comp = authService.getLoggedCompany();

        if ($rootScope.user !== undefined) {
          if ($rootScope.user.adminFeatures && comp.Company.CanCertificata) {
            var canCertificata = $rootScope.user.adminFeatures.some((af) => {
              if (
                af.IdAdminFeature === EAdminFeatures.CanCertificataIntegrate
              ) {
                return true;
              }
            });

            var tokenApi = $rootScope.user.certificataTokenApi;

            if (
              canCertificata &&
              (tokenApi === undefined || tokenApi === null)
            ) {
              return true;
            }
          }
        }
        return false;
      }

      function canCancelCheckout() {
        if ($rootScope.isOnlyOfficeEditing)
          return false;

        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.some((d) => d.canCancelCheckout);
      }

      function cancelCheckout() {
        $scope.messageTitle = $filter('translate')('CANCEL CHECKOUT');
        $scope.messageDescription = $filter('translate')(
          'CONFIRM CANCEL CHECKOUT'
        );
        $scope.messageForward = $filter('translate')('YES');
        $scope.messageCancel = $filter('translate')('NO');

        if (!$scope.canCancelCheckout()) {
          swal.fire($filter('translate')('NO CANCEL CHECKOUT PERMISSION'));
          return;
        }

        $scope.docs = $scope.selectedDocuments();
        var inCheckout = $scope.docs.some((d) => d.idStatus === 5);

        if (inCheckout) {
          $scope.modalRemoveDocument = uibModal.open({
            scope: $scope,
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modal/questionModal/questionModal.html',
            controller: 'cancelCheckoutModalController',
            size: 'small',
            windowClass: 'modal-remove',
            resolve: {
              revisions: () => $scope.docs,
            },
          });
        }
      }

      function cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function questionModal() {
        var ids = $scope.docs.map((r) => r.id);
        return new Promise((resolve) => {
          revisionListService
            .cancelCheckout(ids)
            .then(() => {
              for (var i = 0; i < $scope.docs.length; i++) {
                var rev = $scope.docs[i];
                rev.revisionCheckout = null;
                rev.idStatus = 1;
                rev.updatePermissions();
              }
              resolve();
              $scope.modalRemoveDocument.close();
            })
            .catch((err) => {
              swal.insertQueueStep({
                title: err.error,
                text: err.errorDescription,
                icon: 'error',
              });
              resolve();
            });
        });
      }

      function canDelete() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        const isTemp = $rootScope.user && $rootScope.user.isTempUser;

        if ($rootScope.user !== undefined) {
          $rootScope.user.adminFeatures.forEach((data) => {
            if (data.IdAdminFeature === EAdminFeatures.ManageWorkflows) {
              $scope.PermFeature = true;
            }
          });

          if (isTemp)
            return false;

          if ($scope.PermFeature === true) {
            if (docs[0] !== undefined) {
              if (docs[0].canDelete !== false) {
                return true;
              } else {
                return false;
              }
            }
          }
          if (docs[0] !== undefined) {
            if (
              (docs[0].idStatus === 3 || docs[0].idStatus === 9) &&
              docs[0].idAuthor === $rootScope.user.id
            ) {
              return true;
            }
            if (docs[0].idStatus === 7) {
              return false;
            }
            if (docs[0].canDelete !== false) {
              return true;
            }
          }
        }
      }

      function deleteModel() { }

      function deleteFunc() {
        if (!$scope.canDelete()) {
          swal.fire($filter('translate')('NO REMOVE PERMISSION'));
          return;
        }
        $scope.docs = $scope.selectedDocuments();
        $scope.messageTitle = $filter('translate')('CONFIRM REMOVE');
        $scope.messageDescription = $filter('translate')('REMOVE ?');
        $scope.messageForward = $filter('translate')('REMOVE');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalRemoveDocument = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'removeDocumentModalController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            revisions: () => $scope.docs,
          },
        });
      }

      function canFavorite() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.some((d) => d.canFavorite);
      }

      function canSignDocument() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        return docs.some((d) => d.canSignDocument);
      }

      function canSignDocumentCertificata() {
        if ($rootScope.isOnlyOfficeEditing) return false;

        var docs = $scope.selectedDocuments();
        if (!docs || docs.length !== 1) return false;

        if (!$rootScope.user || !$rootScope.user.certificataTokenApi) return false;

        var doc = docs[0];
        if (!doc) return false;

        if (doc.isSigned === true) return false;

        return (
          doc.canSignCertificate === true &&
          doc.extension === 'pdf' &&
          (doc.certificataDocument === undefined ||
            doc.certificataDocument.length === 0) &&
          doc.idStatus !== 4
        );
      }

      function canViewStatusCertificata() {
        var docs = $scope.selectedDocuments();
        if (
          docs[0] !== undefined &&
          docs[0].certificataDocument !== undefined
        ) {
          if (
            docs[0].canSignCertificate &&
            docs[0].extension === 'pdf' &&
            docs[0].certificataDocument.length > 0
          ) {
            return true;
          }
        } else {
          return false;
        }
      }

      function signCertificata() {
        var docs = $scope.selectedDocuments();
        if (!docs || docs.length !== 1) return;
        if (docs[0].isSigned === true) return;

        $scope.docs = docs;
        $rootScope.signCertificataModal = uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/certificataModal/certificataModal.html',
          size: 'small',
          controller: 'signCertificataController',
          resolve: {
            docs: () => $scope.docs,
          },
        });

        $rootScope.signCertificataModal.result.then(() => {
          $scope.loadDocuments();
        });
      }

      function statusCertificata() {
        $scope.docs = $scope.selectedDocuments();
        $scope.statusCertificataModal = uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          templateUrl:
            '/views/modal/statusCertificataModal/statusCertificataModal.html',
          size: 'small',
          controller: 'signCertificataController',
          resolve: {
            docs: () => $scope.docs,
          },
        });
      }

      function sendByEmail() {
        var revisions = $scope.selectedDocuments();

        uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: 'views/documents/send.by.email.html',
          size: 'small',
          controller: 'sendByEmailController',
          resolve: {
            revision: () => revisions[0],
          },
        });
      }

      function signDocument() {
        if (!$scope.canSignDocument())
          return false;

        var revisions = $scope.selectedDocuments();
        var doc = revisions[0]; // ou trate múltiplos se necessário

        checkExpiredBeforeAction(doc, function () {
          var modalInstance = uibModal.open({
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modules/signing/signDocumentPartial.html',
            controller: 'signDocumentsController',
            windowClass: 'sign-modal-window',
            resolve: {
              revisions: () => [revisions],
              inFlow: () => false,
              sealData: function () {
                return "";
              },
            },
          });

          modalInstance.result.then(function (success) {
            if (success) {
              $state.reload();
            }
          });
        });
      }

      function canShowReportDocument() {
        var lstFeatures = [EAdminFeatures.ViewReports];
        var hasAdminFeature = authService.verifyHasAdminFeature(lstFeatures);
        var isAdmin = authService.isAdmin();
        var isSysAdmin = authService.isSysAdmin();

        if (
          hasAdminFeature === true ||
          isAdmin === true ||
          isSysAdmin === true
        ) {
          return true;
        } else {
          return false;
        }
      }

      function canSignDocumentD4s() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs[0] !== undefined) {
          if (docs[0].d4SignDocument !== undefined) {
            if (
              docs[0].d4SignDocument.Status === 'Finalizado' &&
              authService.user.D4SignTokenApi !== undefined
            ) {
              return false;
            } else {
              return true;
            }
          } else if (docs[0].canSignDocumentD4s !== false) {
            return docs.some((d) => d.canSignDocumentD4s);
          }
          return false;
        }
      }

      function signDocumentD4s() {
        var revision = $scope.selectedDocuments()[0];
        $scope.isSignInActions = true;
        uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modules/signing/signDocumentD4s.html',
          controller: 'signDocumentsD4sController',
          resolve: {
            revisions: () => [revision],
            inFlow: () => false,
          },
        });
      }

      function canDownloadD4SignDocument() {
        var docs = $scope.selectedDocuments();

        if (docs.length !== 1) return false;
        if (!docs[0].d4SignDocument) return false;
        $scope.notification = true;
        if (
          docs[0].d4SignDocument.Status === 'Finalizado' &&
          authService.user.D4SignTokenApi !== undefined
        ) {
          $scope.notification = false;
          return true;
        }
        return false;
      }

      function downloadD4SignDocument() {
        var docs = $scope.selectedDocuments();
        var credentials = {
          tokenApi: authService.user.D4SignTokenApi,
          cryptKey: authService.user.D4SignCriptKey,
        };

        var download = signDocumentD4sService.downloadD4SignDocument(
          docs[0].d4SignDocument.UUIdDocument,
          credentials
        );
        download.then(
          function (value) {
            window.open(value.url);
          },
          function (err) {
            swal.fire({
              title: err.title,
              text: $filter('translate')('ERRO DOWNLOAD DOC D4SIGN'),
              icon: 'error',
            });
          }
        );
      }

      function canSeeD4SignDocumentProperties() {
        var docs = $scope.selectedDocuments();

        if (docs[0] !== undefined) {
          if (docs[0].canSignDocumentD4s !== false) {
            if (docs.length !== 1) return false;
            if (docs[0].d4SignDocument === undefined) return false;
            if (docs[0].d4SignDocument.Status === 'Cancelado') return false;

            return true;
          } else {
            return false;
          }
        }
      }

      function canSignedDocumentSeal() {
        var docs = $scope.selectedDocuments();
        if (docs.length !== 1) return false;
        return docs.some((d) => d.canSignDocument);
      }

      function signedDocumentSeal() {
        var revisions = $scope.selectedDocuments();
        var doc = revisions[0];

        checkExpiredBeforeAction(doc, function () {
          uibModal.open({
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modules/signing/signedDocumentSeal.html',
            controller: 'signedDocumentSealController',
            resolve: {
              revisions: () => [revisions],
              inFlow: () => false,
            },
          });
        });
      }

      function signDataView() {
        var idRevision =
          $scope.selectedDocuments()[0].d4SignDocument.IdRevision;
        signDocumentD4sService
          .d4sGetSignatories(idRevision)
          .then(function (response) {
            $scope.d4sDocumentDetails = response;
            $scope.d4SignIdDocument = idRevision;
            uibModal.open({
              scope: $scope,
              animationEnabled: true,
              backdrop: 'static',
              templateUrl: '/views/modules/signing/signDocumentStatus.html',
              controller: 'signDocumentsD4sController',
              resolve: {
                revisions: function () {
                  return $scope.selectedDocuments()[0].d4SignDocument;
                },
              },
            });
          });
      }

      function favorite() {
        if (!$scope.canFavorite()) return;

        var docs = $scope.selectedDocuments();
        var ids = docs.map((d) => d.id);

        revisionListService
          .favorite(ids)
          .then(() => {
            for (var i = 0, len = docs.length; i < len; i++) {
              var rev = docs[i];

              rev.isFavorite = true;
              rev.updatePermissions();
            }
          })
          .catch(() => $scope.$broadcast('dismissLoading'));
      }

      function canUnfavorite() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canUnfavorite);
      }

      function unfavorite() {
        if (!$scope.canUnfavorite()) return;

        var docs = $scope.selectedDocuments();
        var ids = docs.map((d) => d.id);

        revisionListService
          .unfavorite(ids)
          .then(() => {
            for (var i = 0, len = docs.length; i < len; i++) {
              var rev = docs[i];

              rev.isFavorite = false;
              rev.updatePermissions();
            }
          })
          .catch(() => { });
      }

      function canBecomeObsolete() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canBecomeObsolete);
      }

      function becomeObsolete() {
        if (!$scope.canBecomeObsolete()) return;

        $scope.docs = $scope.selectedDocuments();
        $scope.ids = $scope.docs.map((d) => d.id);

        $scope.messageTitle = $filter('translate')('OBSOLETO');
        $scope.messageDescription = $filter('translate')('OBSOLETE QUESTION');

        let pendingDocs = $scope.docs
          .filter((d) => d.idStatus === 8)
          .map((d) => d.title);

        if (pendingDocs.length >= 1) {
          $scope.messageDescription = $sce.trustAsHtml(
            pendingDocs.length === 1
              ? `O documento "${pendingDocs.join(', ')}" possui assinaturas pendentes via integração com Certificata, o processo será cancelado.<br />`
              : `Os documentos "${pendingDocs.join(', ')}" possuem assinaturas pendentes via integração com Certificata, o processo será cancelado.<br />`
          );

          $scope.messageDescription += $sce.trustAsHtml(
            $filter('translate')('CONFIRM OBSOLETO PERMANENTLY')
          );
        }

        $scope.messageForward = $filter('translate')('OBSOLETO');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalBecomeObsolete = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/obsoleteModal/obsoleteModal.html',
          controller: 'obsoleteDocumentModalController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            revisions: () => $scope.docs,
          },
        });
      }

      function canRestoreDocument() {
        if ($rootScope.isOnlyOfficeEditing) return false;
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.canRestoreDocument);
      }

      function restoreDocument() {
        if (!$scope.canRestoreDocument()) return;
        var docs = $scope.selectedDocuments();
        var ids = docs.map((d) => d.id);

        revisionListService
          .reactivate(ids)
          .then(() => {
            for (var i = 0, len = docs.length; i < len; i++) {
              var rev = docs[i];

              if (
                rev.revisionCheckout !== undefined &&
                rev.revisionCheckout.Resolved === false
              ) {
                rev.idStatus = 5;
              }

              rev.updatePermissions();
            }

            $state.reload();
          })
          .catch(() => { });
      }

      function restore() {
        $scope.messageDescription = '';
        $scope.docs = $scope.selectedDocuments();
        $scope.messageTitle = $filter('translate')('RESTORE DOCUMENT');

        var BoolStatus;
        $scope.docs.map((d) => {
          if (d.idStatus === 9) {
            BoolStatus = true;
          }
        });

        if (BoolStatus) {
          $scope.messageDescription = $filter('translate')(
            'THE DOCUMENT THIS ASSOCIATION ON A WORKFLOW'
          );
        }

        $scope.messageCancel = $filter('translate')('NO');

        $scope.messageForward = $filter('translate')('YES');
        if (!authService.verifyHasAdminFeature([EAdminFeatures.ManageTrashCan]))
          return;

        $scope.ids = $scope.docs.map((d) => d.id);

        $scope.modalQuestion = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'questionModalController',
          size: 'small',
          windowClass: 'modal-remove',
        });
      }

      function deletePermanently() {
        if (!authService.verifyHasAdminFeature([EAdminFeatures.ManageTrashCan]))
          return;

        $scope.messageTitle = $filter('translate')('REMOVE');
        $scope.messageDescription = $filter('translate')(
          'CONFIRM DELETE PERMANENTLY'
        );
        $scope.messageForward = $filter('translate')('REMOVE');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.docs = $scope.selectedDocuments();
        $scope.ids = $scope.docs.map((d) => d.id);
        $scope.deletePer = true;

        $scope.modalRemoveDocument = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'removePermantlyModalController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            revisions: () => $scope.docs,
          },
        });
      }

      function loadSignersInfo(inWorkflow) {
        var rev = this;
        if (!this.signers) {
          revisionListService
            .loadSignersInfo(
              !rev.isHistory ? rev.id : rev.idRevisionHistory,
              rev.extension,
              inWorkflow,
              rev.isHistory
            )
            .then((data) => {
              rev.signers = [];
              for (var i = 0; i < data.length; i++) {
                var obj = data[i];
                var si = new SignerInfo(obj);
                rev.signers.push(si);
              }
            })
            .catch(() => {
              rev.signers = undefined;
            });
        }
      }

      function onUpdateRevision(event, rev) {
        var r = revisionListService.documents.filter(
          (item) => item.id === rev.id
        )[0];
        if (r) {
          if (
            r.idFolder !== rev.idFolder &&
            $state.current.name === 'home.folder'
          ) {
            r.removed = true;
          } else {
            r.code = rev.code;
            r.title = rev.title;
            r.documentType = rev.documentType;
            r.idDocumentType = rev.idDocumentType;
            r.idStatus = rev.idStatus;
            r.description = rev.description;
          }
        }
      }

      function onReloadDocuments() {
        revisionListService.documents = null;
        $scope.groups = null;
        $scope.pageCount = 1;
        $scope.loadDocuments();
      }

      function checkExpiredBeforeAction(doc, onProceed) {
        if (!doc || !doc.isExpired || !doc.isExpired()) {
          onProceed();
          return;
        }

        var modalInstance = uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          keyboard: false,
          templateUrl: '/views/modal/expiredDocumentModal/expiredDocumentModal.html',
          controller: 'expiredDocumentModalController',
          size: 'md',
          windowClass: 'modal-expired-document',
          resolve: {
            revision: () => doc
          }
        });

        modalInstance.result
          .then(function (updated) {
            if (updated) {
              onProceed(); // usuário atualizou → continua
            }
          })
          .catch(function () {
            // Cancelou → não faz nada (não abre edição/assinatura/chancela)
          });
      }

      function canReprocessOcr() {
        if ($rootScope.isOnlyOfficeEditing) return false;

        var docs = $scope.selectedDocuments();
        if (!docs || docs.length !== 1) return false;

        return (authService.isAdmin() || authService.isSysAdmin()) && docs[0].isDigitalization === false;
      }

      function reprocessOcr() {
        var docs = $scope.selectedDocuments();
        if (!docs || docs.length !== 1) return;

        var idRevision = docs[0].id;

        revisionService.reprocessOcr(idRevision).then(
          function () {
            swal.fire({
              title: 'Sucesso',
              text: 'Documento enviado para reprocessamento de OCR.',
              icon: 'success',
              showConfirmButton: true,
            });

            if ($scope.loadDocuments) {
              $scope.loadDocuments();
            }
          },
          function (err) {
            swal.fire({
              title: 'Erro',
              text: err.error_description || err.error || 'Falha ao reprocessar OCR.',
              icon: 'error',
              showConfirmButton: true,
            });
          }
        );
      }

      function hasMoreMenuActions() {
        if (!hasDocumentSelected() || $rootScope.isOnlyOfficeEditing) {
          return false;
        }

        if (
          ($rootScope.user && $rootScope.user.isTempUser) ||
          $scope.isAutologin()
        ) {
          return false;
        }

        return (
          canSendFiles() === true ||
          hasViewPermission() === true ||
          canDownload() === true ||
          canSignDocument() === true ||
          canPublicLink() === true ||
          canCheckout() === true ||
          canCancelCheckout() === true ||
          canShareDocuments() === true ||
          canFavorite() === true ||
          canUnfavorite() === true ||
          canBecomeObsolete() === true ||
          canRestoreDocument() === true ||
          canLinkDocument() === true ||
          canEditDocumentLink() === true ||
          canDelete() === true
        );
      }

      function run() {
        try {
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.carregaMais = logWrapper(
            carregaMais,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.documents = logWrapper(
            documents,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearSelection = logWrapper(
            clearSelection,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectDocument = logWrapper(
            selectDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.roadToFlow = logWrapper(
            roadToFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedDocuments = logWrapper(
            selectedDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasDocumentSelected = logWrapper(
            hasDocumentSelected,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canChangeProperties = logWrapper(
            canChangeProperties,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.configColumns = logWrapper(
            configColumns,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleColumn = logWrapper(
            toggleColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSendFiles = logWrapper(
            canSendFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectorAct = logWrapper(
            selectorAct,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectorAll = logWrapper(
            selectorAll,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasDocuments = logWrapper(
            hasDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumn = logWrapper(
            sortColumn,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isAutologin = logWrapper(
            isAutologin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canLinkDocument = logWrapper(
            canLinkDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasLinkedDocuments = logWrapper(
            hasLinkedDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.linkDocument = logWrapper(
            linkDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCancelLinkedDocuments = logWrapper(
            canCancelLinkedDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelLinkedDocuments = logWrapper(
            cancelLinkedDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.resetMainDocumentLink = logWrapper(
            resetMainDocumentLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canEditDocumentLink = logWrapper(
            canEditDocumentLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canAuditDocuments = logWrapper(
            canAuditDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.editDocumentLink = logWrapper(
            editDocumentLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.doEditDocumentLink = logWrapper(
            doEditDocumentLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.clearLinkFilesVars = logWrapper(
            clearLinkFilesVars,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelLinkFiles = logWrapper(
            cancelLinkFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectLinkFile = logWrapper(
            selectLinkFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.changeMainLinkedDocument = logWrapper(
            changeMainLinkedDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.reorderLinkedFiles = logWrapper(
            reorderLinkedFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.moveLinkedFile = logWrapper(
            moveLinkedFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeFromLink = logWrapper(
            removeFromLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.countLinks = logWrapper(
            countLinks,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isLoadingLinks = logWrapper(
            isLoadingLinks,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateDocs = logWrapper(
            updateDocs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.doLinkFiles = logWrapper(
            doLinkFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getVisibleColumns = logWrapper(
            getVisibleColumns,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getClass = logWrapper(
            getClass,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getDescription = logWrapper(
            getDescription,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newCheckin = logWrapper(
            newCheckin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isTrashCanHelp = logWrapper(
            isTrashCanHelp,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canReplace = logWrapper(
            canReplace,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canReplaceFileSigned = logWrapper(
            canReplaceFileSigned,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canReplaceFile = logWrapper(
            canReplaceFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.replaceFile = logWrapper(
            replaceFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkinFiles = logWrapper(
            checkinFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canMove = logWrapper(
            canMove,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canShareDocuments = logWrapper(
            canShareDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canPublicLink = logWrapper(
            canPublicLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canConvertToPdf = logWrapper(
            canConvertToPdf,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSendByEmail = logWrapper(
            canSendByEmail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.shareDocuments = logWrapper(
            shareDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canViewDocument = logWrapper(
            canViewDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasViewPermission = logWrapper(
            hasViewPermission,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveDocumentLog = logWrapper(
            saveDocumentLog,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.properties = logWrapper(
            properties,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.view = logWrapper(
            view,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.extractSearch = logWrapper(
            extractSearch,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.viewDoc = logWrapper(
            viewDoc,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openView = logWrapper(
            openView,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDownload = logWrapper(
            canDownload,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.download = logWrapper(
            download,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canOnlyOffice = logWrapper(
            canOnlyOffice,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onlyOffice = logWrapper(
            onlyOffice,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateShowBar = logWrapper(
            updateShowBar,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setupOnlyOffice = logWrapper(
            setupOnlyOffice,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.exitOnlyOfficeEditing = logWrapper(
            exitOnlyOfficeEditing,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.finishClose = logWrapper(
            finishClose,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeOnlyOffice = logWrapper(
            closeOnlyOffice,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hideEditorAndSync = logWrapper(
            hideEditorAndSync,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.pollRevisionStatus = logWrapper(
            pollRevisionStatus,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelCheckoutAndClose = logWrapper(
            cancelCheckoutAndClose,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.finishCancelAndClose = logWrapper(
            finishCancelAndClose,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDownloadDigitray = logWrapper(
            canDownloadDigitray,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.downloadDigitray = logWrapper(
            downloadDigitray,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCheckin = logWrapper(
            canCheckin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCheckout = logWrapper(
            canCheckout,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkout = logWrapper(
            checkout,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCertificataInsertCredential = logWrapper(
            canCertificataInsertCredential,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canCancelCheckout = logWrapper(
            canCancelCheckout,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelCheckout = logWrapper(
            cancelCheckout,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDelete = logWrapper(
            canDelete,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.delete = logWrapper(
            deleteFunc,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canFavorite = logWrapper(
            canFavorite,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSignDocument = logWrapper(
            canSignDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSignDocumentCertificata = logWrapper(
            canSignDocumentCertificata,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canViewStatusCertificata = logWrapper(
            canViewStatusCertificata,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signCertificata = logWrapper(
            signCertificata,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.statusCertificata = logWrapper(
            statusCertificata,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendByEmail = logWrapper(
            sendByEmail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signDocument = logWrapper(
            signDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canShowReportDocument = logWrapper(
            canShowReportDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSignDocumentD4s = logWrapper(
            canSignDocumentD4s,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signDocumentD4s = logWrapper(
            signDocumentD4s,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canDownloadD4SignDocument = logWrapper(
            canDownloadD4SignDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.downloadD4SignDocument = logWrapper(
            downloadD4SignDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSeeD4SignDocumentProperties = logWrapper(
            canSeeD4SignDocumentProperties,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSignedDocumentSeal = logWrapper(
            canSignedDocumentSeal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signedDocumentSeal = logWrapper(
            signedDocumentSeal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signDataView = logWrapper(
            signDataView,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.favorite = logWrapper(
            favorite,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canUnfavorite = logWrapper(
            canUnfavorite,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.unfavorite = logWrapper(
            unfavorite,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canBecomeObsolete = logWrapper(
            canBecomeObsolete,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.becomeObsolete = logWrapper(
            becomeObsolete,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canRestoreDocument = logWrapper(
            canRestoreDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.restoreDocument = logWrapper(
            restoreDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.restore = logWrapper(
            restore,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deletePermanently = logWrapper(
            deletePermanently,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadSignersInfo = logWrapper(
            loadSignersInfo,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canShowPreviewButton = logWrapper(
            canShowPreviewButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updatePreview = logWrapper(
            updatePreview,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closePreview = logWrapper(
            closePreview,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.togglePreview = logWrapper(
            togglePreview,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkExpiredBeforeAction = logWrapper(
            checkExpiredBeforeAction,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openExpiredModalForOnlyOffice = logWrapper(
            openExpiredModalForOnlyOffice,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canReprocessOcr = logWrapper(
            canReprocessOcr,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.reprocessOcr = logWrapper(
            reprocessOcr,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasMoreMenuActions = logWrapper(
            hasMoreMenuActions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$on(
            'updateRevision',
            logWrapper(
              onUpdateRevision,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.$on(
            'reloadDocuments',
            logWrapper(
              onReloadDocuments,
              runtimeConstant.isDebugControllersInternals
            )
          );


          $transitions.onSuccess({}, function (transition) {
            var fromState = transition.from();
            var toState = transition.to();

            var fromParams = transition.params('from') || {};
            var toParams = transition.params('to') || {};

            // Só limpa a revisão se a navegação saiu de uma pasta
            // que possuía revisão e mudou de pasta ou de estado.
            var cameFromFolderWithRevision =
              fromState.name === 'home.folder' &&
              fromParams.rev != null &&
              fromParams.rev !== '';

            var changedDestination =
              toState.name !== 'home.folder' ||
              String(toParams.id) !== String(fromParams.id);

            if (!cameFromFolderWithRevision || !changedDestination) {
              return;
            }

            var cleanParams = angular.extend({}, toParams);
            delete cleanParams.rev;

            $state.go(toState.name, cleanParams, {
              location: 'replace',
              notify: false,
              inherit: false
            });
          });

          $rootScope.isOnlyOfficeEditing = false;
          $rootScope.exitOnlyOfficeEditing = $scope.exitOnlyOfficeEditing;
          $rootScope.cancelCheckoutAndClose = $scope.cancelCheckoutAndClose;
          $rootScope.onlyOfficeHasChanges = false;
          $rootScope.onlyOfficeWasSaved = false;
          $rootScope.onlyOfficeIsReady = false;
          $rootScope.onlyOfficeCurrentDocument = null;
          $scope.isDebug = false;
          $scope.init();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
